import styled from 'styled-components'

export const PageWrapper = styled.div`
  max-width: 1024px;
  width: 100%;

  .nft-card-list {
    display: flex;
    flex-wrap: wrap;

    .nft-card-view {
      margin-right: 0.5rem;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .loader {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;

    svg {
      width: 3rem;
      height: 3rem;
    }
  }
`

export const CategoryListWrapper = styled.div`
  width: 100%;
  display: flex;
`

export const FilterListWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 0.75rem;
  justify-content: space-between;

  .filterDropDown {
    border: 1px solid ${({ theme }) => theme.text1};
    padding: 0.5rem;
    font-size: 0.9rem;
    min-height: 36px;
  }

  .currency-filter {
    width: 100%;
    display: flex;
    align-items: center;

    .currency-filter-dropdown {
      width: 150px;

      img {
        width: 18px;
        height: 18px;
      }

      .menu .item {
        justify-content: flex-start;
      }

      .dropdown {
        min-height: 18px;
      }

      .visible.menu.transition {
        font-size: 0.9rem;
        width: 150px;

        span {
          font-size: 0.9rem;
        }

        img {
          width: 18px;
          height: 18px;
        }
      }
    }
  }

  .items-filter {
    display: flex;

    .sort-dropdown {
      width: 170px;
      margin-right: 0.75rem;
    }

    .per-page-dropdown {
      width: 60px;

      .visible.menu.transition {
        width: 56px;
      }
    }
  }
`

export const ConnectWarning = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 3rem;
  font-weight: bold;
`
